// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"053e1763","310":"789b23b7","439":"b3039fca","488":"73bf1948","518":"aa1472ef","563":"b411c72f","579":"4d9179db","632":"b10e315e","718":"be266652","747":"1af38d80","890":"65cc5605","903":"40801f5b"}[chunkId] + ".chunk.js";
};